<template>
  <div>
  <v-dialog v-model="dialog" max-width="600" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-card-title class="headline">
        <div class="nobreak">  {{dialogHeader}}</div>
        </v-card-title>

        <v-card-text>{{dialogContent}}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Close</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>

    
    <v-row  justify-md="center">
      <v-col sm="10" md="7">
        <h1>Settings</h1>
        <v-simple-table class="settings-table" >
          <tbody>
            <tr>
              <th>Display Name</th>
              <td >{{`${ medata.nick_name}#${ medata.nickname_number}`}}</td>
              <td>
                <v-btn @click="displayNameDialog = true;" icon>
                  <v-icon>mdi-pen</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>
                <v-icon color="warning" v-if="!medata.email_verified">mdi-alert</v-icon> Email
                <span v-if="!medata.email_verified">   
                  Unverified <a @click="resendVerificationEmail()">resend email</a>
                </span></th>
              <td >
                <span class="d-inline-block d-sm-inline text-truncate" style="max-width:120px;">{{medata.email}}</span>               
              </td>

              <td>
                <v-btn @click.native.stop="emailDialog = true;" icon>
                  <v-icon>mdi-pen</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Password</th>
              <td>*************</td>
              <td>
                <v-btn @click.native.stop="changePasswordDialog=true" icon>
                  <v-icon>mdi-pen</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr>
              <th>Allow Marketing Emails</th>
              <td colspan="2"> 
                <v-switch :value="medata.promo_email_ok"
                  class="ma-2" 
                  :label="medata.promo_email_ok | boolean"
                  @change="changeAllowMarketing(allowMarketingemails)"
                >
                </v-switch>
              </td>
            </tr>
            <tr>
              <th><v-icon color="#6441a5">mdi-twitch</v-icon> twitch</th>
              <td >
                <div v-if="!hasTwitch">No twitch account linked</div>
                <div v-if="hasTwitch">Account linked</div>
              </td>
              <td>
                <v-btn href="/twitch/link" :loading="loadingTwitch" v-if="!hasTwitch">Link</v-btn>
                <v-btn  v-if="hasTwitch" :loading="loadingTwitch" small @click="unlinkTwitchDialog = true;">Unlink</v-btn>
              </td>
            </tr>

            <tr>
              <td colspan="3"><v-btn color="error" @click="openDeleteAccountDialog()">Delete Account</v-btn></td>
            </tr>
          </tbody>

        </v-simple-table>
      </v-col>
      
    </v-row>

    <v-dialog v-model="unlinkTwitchDialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.mobile">
       <v-card>
          <v-card-title>
            <span class="headline">Unlink twitch account</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  Unlinking your twitch account will remove access to things you have gained through twitch.
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click.native="unlinkTwitchDialog = false;">Cancel</v-btn>
            <v-btn @click="unlinkTwitch()" :loading="unlinkinTwitch">Unlink</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="displayNameDialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.mobile">
      <form @submit.prevent="changeDisplayName" name="form">
        <v-card>
          <v-card-title>
            <span class="headline">Change Display Name dd</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Display Name*"
                    :error-messages="displayNameErrors()"
                    @input="checkProfanity($event)"
                    v-model="$v.displayName.$model"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click.native="closeDisplayNameDialog();">Cancel</v-btn>
            <v-btn type="submit" :disabled="$v.displayName.$invalid">Change Display Name</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>

    <v-dialog v-model="emailDialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.mobile">
      <form @submit.prevent="changeEmail" name="form">
        <v-card>
          <v-card-title>
            <span class="headline">Change Email</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Email*"
                    :error-messages="emailErrors()"
                    v-model="email"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Password*" v-model="password" type="password" required></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click.native="closeEmailDialog()">Cancel</v-btn>
            <v-btn type="submit" :disabled="$v.email.$invalid || $v.password.$invalid">Change Email</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>

    <v-dialog v-model="changePasswordDialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.mobile">
       <form @submit.prevent="changePassword" name="form">
      <v-card>
        <v-card-title>
          <span class="headline">Change Password</span>
        </v-card-title>
        <v-card-text>
          <v-snackbar
            v-model="changePasswordError"
            :color="'error'"
            :timeout="6000"
            :top="true">
           Invalid password
          </v-snackbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Current Password*" 
                  v-model="oldPassword" 
                  type="password" 
                  required
                  :error-messages="oldPasswordErrors()"
                  @input="$v.oldPassword.$touch()"
                  @blur="$v.oldPassword.$touch()">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Password*" 
                v-model="password" 
                type="password" 
                required
                :error-messages="passwordErrors()"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Password*" 
                  v-model="passwordRepeat" 
                  type="password" 
                  required
                  :error-messages="passwordRepeatErrors()"
                  @input="$v.passwordRepeat.$touch()"
                  @blur="$v.passwordRepeat.$touch()">
                  </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" @click.native="closePasswordDialog()">Cancel</v-btn>
          <v-btn type="submit"  :disabled="$v.password.$invalid || $v.oldPassword.$invalid || $v.passwordRepeat.$invalid">Change Password</v-btn>
        </v-card-actions>
      </v-card>
       </form>
    </v-dialog>

     <v-dialog v-model="deleteAccountDialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.mobile">
      <form @submit.prevent="deleteAccount" name="form">
        <v-card >
          <v-card-title color="error">
            <span class="headline">Delete Account?</span>

          </v-card-title>
          <v-card-text>
             <p>
                If you delete your account all data tied to this account will be completely erased after 24 hours.<br /> 
                Before the 24 hours have passed you can restore your account.
            </p>
            <p>To confirm fill in your email and password</p>
            <v-container>
              <v-row>
                 <v-col cols="12">
                  <v-text-field
                    label="Email*"
                     :error-messages="confirmEmailErrors()"
                    v-model="confirmEmail"
                    required
                    @input="$v.confirmEmail.$touch()"
                    @blur="$v.confirmEmail.$touch()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                   
                <v-text-field label="Password*" 
                v-model="password" 
                type="password" 
                required
                :error-messages="passwordErrors()"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click.native="closeDeleteAccountDialog();">Cancel</v-btn>
            <v-btn type="submit" :disabled="$v.password.$invalid" color="error">Delete Account</v-btn>

          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </div>


</template>

<style scoped>
  .verified {
    float:right;
    border: 1px solid green;
    background-color: rgba(117, 243, 117, 0.479);
    padding: 2px 4px;
    border-radius: 5px;
  }
  .unverified {
    float:right;
    color: #000;
    border: 1px solid red;
    background-color: rgba(247, 31, 85, 0.479);
    padding: 2px 4px;
    border-radius: 5px;
  }



</style>
<script>
import { createNamespacedHelpers } from "vuex";
import store from "../store";

import { account } from "../store/modules/account";
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";

import { createFormErrors, invalidCharacters, isProfane } from "../util";

if (!store.state.account) store.registerModule("account", account);

const { mapState } = createNamespacedHelpers("account");

// The first argument is always the passed value. After that any number of arguments may be passed.
const booleanFilter = function(value, trueText, falseText) {
  return value ? trueText || 'Yes' : falseText || 'No';
}

export default {
  name: "Settings",
  filters: {
    boolean: booleanFilter,
  },
  data() {
    return {
      displayName: "",
      email: "",
      password: "",
      oldPassword: "",
      passwordRepeat: "",
      confirmEmail: "",
      changePasswordError: false,
      changePasswordDialog: false,
      allowMarketingemails: false,
      displayNameDialog: false,
      emailDialog: false,
      deleteAccountDialog: false,
      dialog: false,
      dialogHeader: "",
      dialogContent: "",
      loadingTwitch: true,
      hasTwitch: false,
      unlinkTwitchDialog: false,
      unlinkinTwitch: false,
      profanityCheck: false
    };
  },
  validations() {
    return {
      displayName: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(45),
        invalidCharacters
      },
      email: {
        required,
        maxLength: maxLength(512),
        email
      },
      confirmEmail: {
        required,
        sameAs: sameAs("email"),
      },
      oldPassword: {
        required,
        minLength: minLength(1)
      },
      password: {
        required,
        minLength: minLength(1)
      },
      passwordRepeat: {
        required,
        minLength: minLength(4),
        sameAs: sameAs("password")
      }
    };
  },
  computed: {
    ...mapState(["medata"]), 
  },
  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.$store.dispatch("account/me").then(data => {
        this.email = data.email;
        this.displayName = data.nick_name;
        this.allowMarketingEmails = data.promo_email_ok;
      });
      this.$store.dispatch("account/getHasTwitch").then((status) => {
        this.loadingTwitch = false;
        this.hasTwitch = status
      })
    },
    displayNameErrors() {
      return createFormErrors(this.$v.displayName, this.profanityCheck);
    },
    emailErrors() {
      return createFormErrors(this.$v.email);
    },
    passwordErrors() {
      return createFormErrors(this.$v.password);
    },
    passwordRepeatErrors() {
      return createFormErrors(this.$v.passwordRepeat);
    },
    oldPasswordErrors() {
      return createFormErrors(this.$v.oldPassword);
    },
    confirmEmailErrors() {
      return createFormErrors(this.$v.confirmEmail);
    },
    closeDisplayNameDialog() {
      this.displayName = this.medata.nick_name;
      this.displayNameDialog = false;
    },
    closeEmailDialog() {
      this.password = "";
      this.emailDialog = false;
    },
    closePasswordDialog() {
      this.oldPassword = "";
      this.password = "";
      this.passwordRepeat = "";
      this.changePasswordDialog = false;
    },
    openDeleteAccountDialog() {
      this.email = this.medata.email;
      this.deleteAccountDialog = true;
    },
    closeDeleteAccountDialog() {
      this.password = "";
      this.email = "";
      this.confirmEmail = "";
      this.deleteAccountDialog = false;
    },
    changeEmail() {
      this.$store
        .dispatch("auth/changeEmail", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.replace("/");
        }, this.showError("Failed to change email"));
    },
    showError(header) {
      return (err) => {
        this.dialogHeader = header;
        if (err.response && err.response.data && err.response.data.message) {
          this.dialogContent = err.response.data.message;
        } else {
          this.dialogContent = "An unknown error occured";
        }
        this.dialog = true;
      }
    },
    changePassword() {
      this.$store.dispatch("auth/changePassword", {
        oldPassword: this.oldPassword,
        newPassword: this.password,
      }).then(() => {
        this.$router.replace("/");
      }).catch(() => {
        this.changePasswordError = true;
      });
    },
    changeDisplayName() {
      this.$store.dispatch("account/changeDisplayName", {
        displayName: this.displayName,
      }).then(() => {
        this.closeDisplayNameDialog();
      });
    },
    changeAllowMarketing() {
      this.allowMarketingEmails = !this.allowMarketingEmails;
      
      setTimeout(() => {
        this.$store.dispatch("account/changeAllowMarketingEmails", this.allowMarketingEmails)
      }, 300);
    },
    resendVerificationEmail() {
      this.$store.dispatch("account/resendVerificationEmail").then(()=>{

        this.dialogHeader = "Verification email sent"
        this.dialogContent = "An email with an verification link have been sent. If you can't see it within an hour, check your spam folder.";
        this.dialog = true;
      })
    },
    closeMarketingDialog() {
      this.password = '';
      
      this.allowMarketingDialog = false;
    },
    deleteAccount() {
      this.$store.dispatch("auth/deleteAccount", {
        password: this.password,
      }).then(() => {
        this.$router.replace("/");
      }, this.showError("Failed to delete account")) 
    },
    unlinkTwitch() {
      this.unlinkinTwitch = true;
      this.$store.dispatch("account/unlinkTwitch").then(() => {
        this.unlinkinTwitch = false;
        this.unlinkTwitchDialog = false;
        this.hasTwitch = false;
      })
    },
    checkProfanity(input) {
      if (input) {
        if (/^[a-zA-Z0-9_]*$/.test(input) === false) return;
        if (input === '') return;
        if (input.length < 4) return;
        isProfane(input).then(res => this.profanityCheck = !res)
        return this.profanityCheck;
      }
    }
  }
};
</script>